import React, { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from '../../messages';
import { AutomationRulesContext } from '../../context';
import { FilterEditorContext } from '../../../../../components/filter-editor/context';
import { useOpenRuleDrawer } from '../../hooks/use-open-rule-drawer';
import { EventSourceStrings } from '../../../../../tracking/tracking-constants';
import { AutomationRulesSteps, useTrackAutomationRulesWorkflow } from '../../hooks/use-track-automation-rules-workflow';

/** @param {{ automationRuleId: string }} props */
export const RuleEditorLink = ({ automationRuleId }) => {
  const { automationRules } = useContext(AutomationRulesContext);
  const { filterSets } = useContext(FilterEditorContext);
  const openRuleDrawer = useOpenRuleDrawer();
  const trackStart = useTrackAutomationRulesWorkflow(AutomationRulesSteps.START);
  const openDrawer = useCallback(() => {
    const rule = automationRules.find((r) => r.automationRuleId === automationRuleId);
    openRuleDrawer({
      rule,
      name: rule.name,
      filterSet: filterSets[rule.filterId],
    });
    trackStart({
      rule,
      source: EventSourceStrings.RULE_EDITOR_LINK,
      isAiGenerated: false,
    });
  }, [automationRuleId, automationRules, openRuleDrawer, filterSets, trackStart]);

  return (
    <DropdownMenuItem onClick={openDrawer} theme='link'>
      <FormattedMessage {...messages.edit} />
    </DropdownMenuItem>
  );
};
